const loadCollection = async () => {
  let e = document.querySelector(".collection .product-list");
  e && (e.style.opacity = ".2"),
    window.scrollTo({ top: 0, behavior: "smooth" });
  let t = await fetch(window.location.href),
    o = await t.text(),
    l = new DOMParser(),
    r = l.parseFromString(o, "text/html");
  document
    .querySelector(".collection")
    ?.replaceWith(r.querySelector(".collection")),
    document
      .querySelectorAll("#offcanvas-filters .collapse-inner")
      .forEach((e) => {
        let t = e.closest(".collapse").getAttribute("id");
        e.replaceWith(
          r.querySelector(`#offcanvas-filters #${t} .collapse-inner`)
        );
      }),
    document
      .querySelector("#offcanvas-filters .offcanvas-footer")
      ?.replaceWith(r.querySelector("#offcanvas-filters .offcanvas-footer")),
    document
      .querySelector("#offcanvas-filters .btn-filters-clear-all")
      ?.replaceWith(
        r.querySelector("#offcanvas-filters .btn-filters-clear-all")
      ),
    document
      .querySelector('#offcanvas-filters [name="sort_by"]')
      ?.replaceWith(r.querySelector('#offcanvas-filters [name="sort_by"]')),
    document
      .querySelectorAll('.collection [data-bs-toggle="popover"]')
      .forEach((e) => bootstrap.Popover.getOrCreateInstance(e));
  let i = new CustomEvent("updated.ecomify.collection");
  window.dispatchEvent(i);
};
window.onChangeCollectionFilter = async (e, t) => {
  let o = e.closest("form"),
    l = new URLSearchParams(new FormData(o)),
    r = `${window.location.pathname}?${l.toString()}`;
  window.history.replaceState({}, "", r), await loadCollection();
};
const initCollectionFiltersPriceChange = () => {
  document.querySelectorAll(".filter-price-group input").forEach((e) => {
    e.addEventListener(
      "input",
      window.debounce(async (t) => {
        let o = e.closest("form"),
          l = new URLSearchParams(new FormData(o)),
          r = `${window.location.pathname}?${l.toString()}`;
        window.history.replaceState({}, "", r), await loadCollection();
      }, 750)
    );
  });
};
initCollectionFiltersPriceChange(),
  window.addEventListener(
    "updated.ecomify.collection",
    initCollectionFiltersPriceChange
  ),
  (window.onClickFiltersViewMore = (e, t) => {
    e
      .closest(".collapse")
      .querySelectorAll(".form-check")
      .forEach((e) => {
        e.removeAttribute("hidden");
      }),
      e.remove();
  }),
  (window.onClickClearAllFilters = async (e, t) => {
    let o = e.closest("form"),
      l = new URLSearchParams();
    l.set("sort_by", o.querySelector('[name="sort_by"]').value);
    let r = `${window.location.pathname}?${l.toString()}`;
    window.history.replaceState({}, "", r), await loadCollection();
  });
const initPriceFilterSlider = () => {
  document.querySelectorAll(".filter-price-group-slider").forEach((e) => {
    let t = e.closest("form").querySelector('[name="filter.v.price.gte"]'),
      o = e.closest("form").querySelector('[name="filter.v.price.lte"]');
    e && e.noUiSlider && e.noUiSlider.destroy(),
      noUiSlider.create(e, {
        start: [Number(e.dataset.minValue), Number(e.dataset.maxValue)],
        connect: !0,
        range: {
          min: Number(e.dataset.rangeMin),
          max: Number(e.dataset.rangeMax),
        },
      }),
      e.noUiSlider.on("update", function (e) {
        (t.value = e[0]), (o.value = e[1]);
      }),
      e.noUiSlider.on("change", function () {
        let e = new Event("input");
        t.dispatchEvent(e), o.dispatchEvent(e);
      });
  });
};
initPriceFilterSlider(),
  window.addEventListener("updated.ecomify.collection", initPriceFilterSlider),
  (window.onChangeCollectionSortBy = (e) => {
    let t = new URLSearchParams(window.location.search);
    t.set("sort_by", e);
    let o = `${window.location.pathname}?${t.toString()}`;
    window.history.replaceState({}, "", o), loadCollection();
  }),
  (window.onClickCollectionLoadMore = async (e, t) => {
    t.preventDefault(),
      (e.style.width = `${e.offsetWidth + 2}px`),
      (e.style.height = `${e.offsetHeight + 2}px`),
      (e.innerHTML = `
        <div class="spinner-border spinner-border-sm mx-auto" role="status" style="width: 1.2rem; height: 1.2rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `),
      window.history.replaceState({}, "", e.dataset.nextUrl);
    let o = await fetch(window.location.href),
      l = await o.text(),
      r = new DOMParser(),
      i = r.parseFromString(l, "text/html");
    document
      .querySelector(".collection .product-list")
      .insertAdjacentHTML(
        "beforeend",
        i.querySelector(".collection .product-list").innerHTML
      ),
      document
        .querySelector("#collection-pagination")
        .replaceWith(i.querySelector("#collection-pagination")),
      document
        .querySelectorAll('.collection [data-bs-toggle="popover"]')
        .forEach((e) => bootstrap.Popover.getOrCreateInstance(e));
    let c = new CustomEvent("updated.ecomify.collection");
    window.dispatchEvent(c);
  }),
  (window.onClickCollectionLoadPrevious = async (e, t) => {
    t.preventDefault(),
      (e.style.width = `${e.offsetWidth + 2}px`),
      (e.style.height = `${e.offsetHeight + 2}px`),
      (e.innerHTML = `
        <div class="spinner-border spinner-border-sm mx-auto" role="status" style="width: 1.2rem; height: 1.2rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `),
      window.history.replaceState({}, "", e.dataset.previousUrl);
    let o = await fetch(window.location.href),
      l = await o.text(),
      r = new DOMParser(),
      i = r.parseFromString(l, "text/html");
    document
      .querySelector(".collection .product-list")
      .insertAdjacentHTML(
        "afterbegin",
        i.querySelector(".collection .product-list").innerHTML
      ),
      document
        .querySelector("#btn-load-previous")
        ?.replaceWith(i.querySelector("#btn-load-previous")),
      document
        .querySelectorAll('.collection [data-bs-toggle="popover"]')
        .forEach((e) => bootstrap.Popover.getOrCreateInstance(e));
    let c = new CustomEvent("updated.ecomify.collection");
    window.dispatchEvent(c);
  });
const initPaginationObserver = () => {
  let e = document.querySelector("#collection-pagination");
  if (!e) return;
  let t = new IntersectionObserver(
    (t) => {
      t.forEach((t) => {
        if (t.isIntersecting) {
          let o = e.querySelector(".btn-load-more");
          o && o.click();
        }
      });
    },
    { threshold: 0, rootMargin: "0px 0px -100px 0px" }
  );
  t.observe(e);
};
initPaginationObserver(),
  window.addEventListener("updated.ecomify.collection", initPaginationObserver);
const fixedUtilitiesBarOnScroll = () => {
  let e = document.querySelector("#collection-utilities");
  if (!e) return;
  let t =
      document.querySelector('[id*="__navbar"].sticky-top')?.clientHeight || 0,
    o =
      document.querySelector('[id*="__announcement-bar"].sticky-top')
        ?.clientHeight || 0;
  document.addEventListener(
    "scroll",
    window.throttle(() => {
      window.scrollY > 700
        ? (e.classList.add("sticky-top"),
          (e.style.top = `${t + o}px`),
          setTimeout(() => {
            e.classList.add("show");
          }, 200))
        : (e.classList.remove("show"),
          setTimeout(() => {
            e.classList.remove("sticky-top"), (e.style.top = "0");
          }, 200));
    }, 200)
  ),
    setInterval(() => {
      window.scrollY < 50 &&
        (e.classList.remove("sticky-top"), (e.style.top = "0"));
    }, 1e3);
};
fixedUtilitiesBarOnScroll(),
  window.addEventListener("updated.ecomify.collection", () =>
    setTimeout(() => {
      fixedUtilitiesBarOnScroll();
    }, 1e3)
  );
const handleScrollTopButton = () => {
  let e = document.querySelector("#btn-collection-scroll-top"),
    t = document.querySelector(".collection .product-list");
  if (!e || !t) return;
  let o = t.getBoundingClientRect().top;
  document.addEventListener(
    "scroll",
    window.throttle(() => {
      window.scrollY > o
        ? e.classList.add("btn-show")
        : e.classList.remove("btn-show");
    }, 200)
  );
};
handleScrollTopButton(),
  window.addEventListener("updated.ecomify.collection", handleScrollTopButton),
  (window.showAllSwatchesWithinProductItem = (e, t) => {
    let o = e.closest(".color-swatches");
    o.querySelectorAll("li").forEach((e) => {
      e.removeAttribute("hidden");
    }),
      e.remove();
  });
